// Scans.tsx
import React from 'react'
import { UserOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import {
  ScanReportWrapper,
  LoadingContainer,
  Container,
  LeftBar,
  LeftBarContainer,
  LeftBarText,
  RightBar,
  RightBarContainer,
  RightBarText,
  HexagonContainer,
  Hexagon,
  HexagonLabel,
  LeftCircle,
  RightCircle,
  Title,
  Subtitle,
  Wrapper,
  Card,
  Info,
  NavWrapper,
  NavButton,
  Score,
  DoctorProfile,
  ErrorContainer,
} from './index.styled'
import { useScans } from './useScans'

import DefaultAvatar from '../../../../../images/DefaultAvatar.svg'
import { APIStatus } from '../../../../../redux/types'

export function Scans() {
  const {
    scans,
    isScanEmpty,
    scansStatus,
    scansByIdStatus,
    scansById,
    scanReport,
    isLoading,
    currentPage,
    lastPageIndex,
    processFinished,
    scanDate,
    defaultScanReport,
    handlePreviousScan,
    handleNextScan,
  } = useScans()

  // ---------------------
  // Render logic: mirrors original exactly, but uses local statuses
  // ---------------------
  if (isLoading === true) {
    return (
      <ScanReportWrapper>
        <LoadingContainer>
          <Spin />
        </LoadingContainer>
        <Wrapper></Wrapper>
      </ScanReportWrapper>
    )
  } else {
    return isScanEmpty === true ? (
      <ScanReportWrapper>
        {scansStatus === APIStatus.fulfilled && (
          <>
            {defaultScanReport.map((scan: any, idx: number) => {
              return (
                <Container key={idx}>
                  <LeftBarContainer>
                    <LeftBar
                      style={{
                        width: `${scan.value}px`,
                        borderBottom: `32px solid #007F7C`,
                      }}
                    ></LeftBar>
                  </LeftBarContainer>
                  <HexagonContainer>
                    <Hexagon>
                      <HexagonLabel>{scan.spineLevel}</HexagonLabel>
                    </Hexagon>
                  </HexagonContainer>
                  <RightBarContainer>
                    <RightBar
                      style={{
                        width: `${scan.value}px`,
                        borderBottom: `32px solid #007F7C`,
                      }}
                    ></RightBar>
                  </RightBarContainer>
                </Container>
              )
            })}
          </>
        )}
        <Wrapper>
          <Card>
            <DoctorProfile size={50} shape="circle" icon={<UserOutlined />} />

            <Info>
              <Title>{'-'}</Title>
              <Subtitle>{'-'}</Subtitle>
            </Info>
            <Score style={{ marginLeft: 'auto' }}>{'-'}</Score>
          </Card>

          <NavWrapper>
            <NavButton
              style={{
                color: 'var(--color-disabled)',
                borderColor: 'var(--color-disabled)',
              }}
            >
              Previous
            </NavButton>
            <NavButton
              style={{
                color: 'var(--color-disabled)',
                borderColor: 'var(--color-disabled)',
              }}
            >
              Next
            </NavButton>
          </NavWrapper>
        </Wrapper>
      </ScanReportWrapper>
    ) : (
      <ScanReportWrapper>
        {scansByIdStatus === APIStatus.pending && (
          <LoadingContainer>
            <Spin />
          </LoadingContainer>
        )}
        {scansByIdStatus === APIStatus.fulfilled && scanReport && processFinished && (
          <>
            {scanReport?.map((scan: any, idx: number) => {
              return (
                <Container key={idx}>
                  <LeftBarContainer>
                    {scan.userScanId !== scans?.firstScan?.id &&
                      scans?.userScan &&
                      scans?.userScan?.length > 1 &&
                      scan.dotInfo.shouldShowLeftDot && (
                        <LeftCircle
                          style={{
                            position: 'absolute',
                            right: `${scan.dotInfo.leftDotPosition !== null && scan.dotInfo.leftDotPosition}px`,
                          }}
                        ></LeftCircle>
                      )}
                    <LeftBar
                      style={{
                        width: `${scan.leftBarWidth}px`,
                        minWidth: '40px',
                        maxWidth: '195px',
                        borderBottom: `32px solid ${scan.leftBarColor}`,
                        color: scan.leftBarColor === '#E5E7EB' ? '#050624' : '#E5E7EB',
                      }}
                    >
                      <LeftBarText>
                        {scan.showLeftText === true && scan.hideText !== true && scan.isBothEqual === false
                          ? `${scan.leftTextPercent}%`
                          : ''}
                      </LeftBarText>
                    </LeftBar>
                  </LeftBarContainer>
                  <HexagonContainer>
                    <Hexagon>
                      <HexagonLabel>{scan.spineLevel}</HexagonLabel>
                    </Hexagon>
                  </HexagonContainer>
                  <RightBarContainer>
                    <RightBar
                      style={{
                        width: `${scan.rightBarWidth}px`,
                        minWidth: '40px',
                        maxWidth: '195px',
                        borderBottom: `32px solid ${scan.rightBarColor}`,
                        color: scan.rightBarColor === '#E5E7EB' ? '#050624' : '#E5E7EB',
                      }}
                    >
                      <RightBarText>
                        {scan.showRightText === true && scan.hideText !== true && scan.isBothEqual === false
                          ? `${scan.rightTextPercent}%`
                          : ''}
                      </RightBarText>
                    </RightBar>
                    {scan.userScanId !== scans?.firstScan?.id &&
                      scans?.userScan &&
                      scans?.userScan?.length > 1 &&
                      scan.dotInfo.shouldShowRightDot && (
                        <RightCircle
                          style={{
                            position: 'absolute',
                            left: `${scan.dotInfo.rightDotPosition !== null && scan.dotInfo.rightDotPosition}px`,
                          }}
                        ></RightCircle>
                      )}
                  </RightBarContainer>
                </Container>
              )
            })}
          </>
        )}
        {scansByIdStatus === APIStatus.rejected && scanReport && <ErrorContainer></ErrorContainer>}
        <Wrapper style={{ marginTop: 10 }}>
          <Card>
            <DoctorProfile
              size={48}
              shape="circle"
              icon={
                scansById?.chiroProfilePic ? <img src={scansById.chiroProfilePic} alt="avatar" /> : <UserOutlined />
              }
            ></DoctorProfile>

            <Info>
              <Title>{scanDate?.day}</Title>
              <Subtitle>{scanDate?.studioName}</Subtitle>
            </Info>
            <Score style={{ marginLeft: 'auto' }}>{scansById?.scanScore ?? '-'}</Score>
          </Card>

          <NavWrapper>
            <NavButton
              onClick={handlePreviousScan}
              style={{
                color: currentPage === lastPageIndex ? 'var(--color-disabled)' : '',
                borderColor: currentPage === lastPageIndex ? 'var(--color-disabled)' : '',
              }}
            >
              Previous
            </NavButton>
            <NavButton
              onClick={handleNextScan}
              style={{
                color: currentPage === 0 ? 'var(--color-disabled)' : '',
                borderColor: currentPage === 0 ? 'var(--color-disabled)' : '',
              }}
            >
              Next
            </NavButton>
          </NavWrapper>
        </Wrapper>
      </ScanReportWrapper>
    )
  }
}
